import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';
import classnames from 'classnames';
import { getRequiredFn } from '../../../../../utils/reduxForm/validations';

import { PasswordField } from './PasswordField';

const passwordMinLength = 7;
const passwordDoesNotMatch = 'Пароли не совпадают';
const requiredFn = getRequiredFn();

export default class ChangePasswordSection extends React.Component {
  static propTypes = {
    password: PropTypes.string,
    confirmPassword: PropTypes.string,
  };

  getValidationFlags = () => {
    const { password } = this.props;

    return {
      invalidLength: password.length < passwordMinLength,
      noCaps: !/[A-Z]+/.test(password),
      noLowers: !/[a-z]+/.test(password),
      noDigital: !/[0-9]+/.test(password),
      noSymbols: !/[#$^&*_\-+%@]+/.test(password),
    };
  };

  validatePasswords = (value, allValues) => {
    const newPassword1 = allValues.get('newPassword1');
    const newPassword2 = allValues.get('newPassword2');
    if (newPassword1 === '' || newPassword2 === '') {
      return null;
    }
    return newPassword1 === newPassword2 ? null : passwordDoesNotMatch;
  };

  render() {
    const { invalidLength, noCaps, noLowers, noDigital, noSymbols } = this.getValidationFlags();

    return (
      <div className="profile_password js-add-block">
        <h2 className="H2">{'Сменить пароль для входа в Личный кабинет'}</h2>

        <div className="link link_attention-red">
          {'ВНИМАНИЕ! Новый пароль обязательно должен содержать:'}
        </div>

        <ul className="list list__dark profile_list">
          <li className={classnames({ red: invalidLength })}>{'Не менее 7 символов'}</li>
          <li className={classnames({ red: noCaps })}>{'Прописные латинские буквы (A-Z)'}</li>
          <li className={classnames({ red: noLowers })}>{'Строчные латинские буквы (a-z)'}</li>
          <li className={classnames({ red: noDigital })}>{'Арабские цифры (0-9)'}</li>
          <li className={classnames({ red: noSymbols })}>{'Спецсимволы (#,$,^,&,*,_,-,+,%,@)'}</li>
        </ul>

        <div className="cRow">
          <div className="cCol cCol__33">
            <Field
              name="oldPassword"
              validate={requiredFn}
              component={PasswordField}
              label="Старый пароль"
            />
          </div>

          <div className="cCol cCol__33">
            <Field
              name="newPassword1"
              validate={[requiredFn, this.validatePasswords]}
              component={PasswordField}
              label="Новый пароль"
            />
          </div>

          <div className="cCol cCol__33">
            <Field
              name="newPassword2"
              validate={[requiredFn, this.validatePasswords]}
              component={PasswordField}
              label="Пароль повторно (для контроля)"
            />
          </div>
        </div>
      </div>
    );
  }
}
